import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-39",
  "use": "icon-app_icon-39-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-39\"><g><path d=\"M7 7.054V5a4 4 0 014-4h20a4 4 0 014 4v20a4 4 0 01-4 4h-1.952L29 14l-5.838-6.946\" fill-opacity=\".6\" /><path d=\"M25 7a4 4 0 014 4v20a4 4 0 01-4 4H5a4 4 0 01-4-4V11a4 4 0 014-4h20zm-6.464 7.636L8.13 25.041l-.202 3.03 3.03-.202 10.405-10.405-2.828-2.828zm2.12-2.121l-1.413 1.414 2.828 2.828 1.414-1.414-2.828-2.828z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol